import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Col } from "react-bootstrap";


const DescriptionEditor = ({ formik }) => {
  const modules = {
    toolbar: [
      [{ 'header': [false, 1, 2, 3, 4, 5, 6] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link'
  ];

  const handleChange = (content) => {
    formik.setFieldValue('description', content);
  };

  return (
    <Col md={12}>
      <label>Description</label>
      <div className="mb-3">
        <ReactQuill
          id="description"
          theme="snow"
          value={formik.values.description || ''}
          onChange={handleChange}
          onBlur={() => formik.setFieldTouched('description', true)}
          modules={modules}
          formats={formats}
          className="editor-container"
        />
        <div className="editor-stats">
          <span>Lines: {formik.values.description ? formik.values.description.split('\n').length : 0}</span>
          <span>Words: {formik.values.description ? formik.values.description.replace(/<[^>]*>/g, '').split(/\s+/).filter(Boolean).length : 0}</span>
        </div>
        {formik.touched.description && formik.errors.description && (
          <div className="text-danger">{formik.errors.description}</div>
        )}
      </div>
    </Col>
  );
};

export default DescriptionEditor;